import React, { Component } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import * as selectors from 'selectors';
import KeyboardHandler from 'react-key-handler';
import { scroller } from 'react-scroll';

class SectionKeyHandlers extends Component {
  scrollDown = (e) => {
    e.preventDefault();

    const nextIndex = `scroll-${this.props.scrollPosition + 1}`;
    scroller.scrollTo(nextIndex, {
      duration: 300,
      smooth: true,
      containerId: 'wrapper',
    });
  };
  scrollUp = (e) => {
    e.preventDefault();

    const nextIndex = `scroll-${this.props.scrollPosition - 1}`;
    scroller.scrollTo(nextIndex, {
      duration: 300,
      smooth: true,
      containerId: 'wrapper',
    });
  };

  render() {
    const {
      arrowLeftHandler,
      arrowRightHandler,
      escHandler,
      enterHandler,
      spaceHandler,
      active,
      children,
    } = this.props;
    return (
      <React.Fragment>
        {active ? (
          <React.Fragment>
            {arrowLeftHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue="ArrowLeft"
                onKeyHandle={arrowLeftHandler}
              />
            )}
            {arrowRightHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue="ArrowRight"
                onKeyHandle={arrowRightHandler}
              />
            )}
            {enterHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue="Enter"
                onKeyHandle={enterHandler}
              />
            )}
            {escHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue="Escape"
                onKeyHandle={escHandler}
              />
            )}
            {escHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue="Escape"
                onKeyHandle={escHandler}
              />
            )}
            {spaceHandler && (
              <KeyboardHandler
                keyEventName="keydown"
                keyValue=" "
                onKeyHandle={spaceHandler}
              />
            )}
          </React.Fragment>
        ) : null}
        {children}
      </React.Fragment>
    );
  }
}

SectionKeyHandlers.defaultProps = {
  arrowLeftHandler: null,
  arrowRightHandler: null,
  escHandler: null,
  enterHandler: null,
  spaceHandler: null,
};
SectionKeyHandlers.propTypes = {
  arrowLeftHandler: T.func,
  arrowRightHandler: T.func,
  escHandler: T.func,
  enterHandler: T.func,
  spaceHandler: T.func,
  active: T.bool.isRequired,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
});

export default connect(mapStateToProps)(SectionKeyHandlers);



// WEBPACK FOOTER //
// ./src/components/modules/SectionKeyHandlers/SectionKeyHandlers.js